<template>
    <div
        class="bg-style1"
        style="display: flex; justify-content: space-between"
    >
        <iframe
            :src="`https://open.ys7.com/ezopen/h5/iframe_se?url=ezopen://open.ys7.com/G12026247/1.live&autoplay=1&audio=1&accessToken=${this.control}&templete=2`"
            width="31%"
            height="200"
            id="ysopen"
            allowfullscreen
        >
        </iframe>

        <iframe
            :src="`https://open.ys7.com/ezopen/h5/iframe_se?url=ezopen://open.ys7.com/G12026247/2.live&autoplay=1&audio=1&accessToken=${this.control}&templete=2`"
            width="31%"
            height="200"
            id="ysopen"
            allowfullscreen
        >
        </iframe>
        <iframe
            :src="`https://open.ys7.com/ezopen/h5/iframe_se?url=ezopen://open.ys7.com/G12026247/4.live&autoplay=1&audio=1&accessToken=${this.control}&templete=2`"
            width="31%"
            height="200"
            id="ysopen"
            allowfullscreen
        >
        </iframe>
        <!-- <ul>
      <li>
        <iframe
        src="https://open.ys7.com/ezopen/h5/iframe_se?url=ezopen://open.ys7.com/E60167235/1.live&autoplay=1&audio=1&accessToken=at.91ryaacu4px3vufc64aqwf9ndpl3k7gk-67w5hvxb6i-0caeunm-8trebo2cf&templete=2"
        width="300"
        height="200"
        id="ysopen"
        allowfullscreen
      >
      </iframe>
      </li>
      <li>
        <iframe
        src="https://open.ys7.com/ezopen/h5/iframe_se?url=ezopen://open.ys7.com/E60167235/3.live&autoplay=1&audio=1&accessToken=at.91ryaacu4px3vufc64aqwf9ndpl3k7gk-67w5hvxb6i-0caeunm-8trebo2cf&templete=2"
        width="300"
        height="200"
        id="ysopen"
        allowfullscreen
      >
      </iframe>
      </li>
    </ul> -->
    </div>
</template>

<script>
import request from "@/utils/request.js"
export default {
    data() {
        return {
            tableData: [],
            pageOne: { pageSize: 10, pageNo: 1, total: 0 },
            accessKey:'f53a1def26d34d6dbdc91a6b70dbd9b2',
            accessSecret:'70d7c4cf7dd218786a57d0bf95f38d47',
            control:""
        }
    },
    computed: {
        // videoPlayerUrl() {
        // let con =
        //     "https://open.ys7.com/ezopen/h5/iframe_se?url=ezopen://open.ys7.com/G12026247/2.live&autoplay=1&audio=1&accessToken="+ this.control + "&templete=2"
        // return con
        // }
    },

    mounted() {
        // this.getList()
        this.getvode()
    },
    methods: {
        // 获取数据
        getList() {
            let params = {
                pageNo: this.pageOne.pageNo,
                pageSize: this.pageOne.pageSize,
                customerName: this.customerName,
            }
            this.$http.request({
                url: "/ypt/admin/customerHealthWarn/info/findList",
                method: "POST",
                data: params,
            })
            .then((res) => {
                if (res.code == 200) {
                    if (res.content == null || res.content == "null") {
                        console.log(res.code)
                        this.tableData = []
                        this.pageOne.total = 0
                        return
                    }
                    this.tableData = res.content.list
                    this.pageOne.total = res.content.count
                }
            })
        },
        //获取监控链接
        getvode(){
            fetch("https://open.ys7.com/api/lapp/token/get", {
                method: "POST", // or 'PUT'
                body: `appKey=${this.accessKey}&appSecret=${this.accessSecret}`, 
                headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                },
            }).then((res) => res.json())
                .then((res) => {
                    this.control = res.data.accessToken
                    this.videoPlayerUrl = 'https://open.ys7.com/ezopen/h5/iframe_se?url=ezopen://open.ys7.com/G12026247/2.live&autoplay=1&audio=1&accessToken=' + this.control +'&templete=2'
                    console.log('https://open.ys7.com/ezopen/h5/iframe_se?url=ezopen://open.ys7.com/G12026247/2.live&autoplay=1&audio=1&accessToken=' + this.control +'&templete=2');
                })
        }
    },
}
</script>

<style lang="less" scoped>
.bg-style1 {
    width: 100%;
    padding: 20px;
    ul {
        display: flex;
        justify-content: space-between;
    }
    li {
        float: left;
        width: 240px;
        height: 150px;
        img {
            width: 100%;
        }
    }
}
</style>